import React, { useEffect, useState } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

function feePct(fee) {
  if (!fee) return "";
  return `${(fee / 10000).toFixed(2)}%`;
}

export default function New() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastRead, setLastRead] = useState(null);

  useEffect(() => {
    let stop = false;
    async function poll() {
      try {
        const { data } = await axios.get(`${API}/new`, { timeout: 8000 });
        if (stop) return;
        setRows(data || []);
        setLastRead(new Date());
      } catch (e) {
        // keep last good
      } finally {
        setLoading(false);
      }
    }
    poll();
    const id = setInterval(poll, 30_000);
    return () => { stop = true; clearInterval(id); };
  }, []);

  return (
    <div style={{ maxWidth: 1520, margin: "0 auto", padding: "48px 28px 40px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 8 }}>
        <h1 className="serif" style={{ fontSize: 52, letterSpacing: "-0.02em", margin: 0 }} data-testid="new-title">
          New.
        </h1>
        <div style={{ color: "var(--ink-muted)", fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase" }}>
          {loading ? "reading…" : `${rows.length} recent pools`}
        </div>
      </div>
      <div style={{ color: "var(--ink-muted)", fontSize: 14, marginBottom: 24 }}>
        Size after the line. Read from Robinhood Chain.
      </div>

      <table className="book tabular" data-testid="new-table">
        <thead>
          <tr>
            <th>Ticker</th><th>Pair</th><th>Quote</th><th>Fee</th><th>Age</th><th>Pool</th><th></th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && !loading && (
            <tr><td colSpan={7} style={{ color: "var(--ink-muted)", padding: 30 }}>No new pools in the last 24h.</td></tr>
          )}
          {rows.map((n, i) => (
            <tr key={(n.pool || "") + i}>
              <td style={{ fontSize: 15 }}>{n.ticker}</td>
              <td style={{ color: "var(--ink-muted)" }}>{n.pair}</td>
              <td>{n.quote}</td>
              <td>{feePct(n.fee)}</td>
              <td style={{ color: "var(--ink-muted)" }}>{n.age}</td>
              <td style={{ color: "var(--ink-muted)", fontSize: 11 }}>
                {n.pool ? (
                  <a href={`https://robinhoodchain.blockscout.com/address/${n.pool}`} target="_blank" rel="noreferrer" style={{ color: "var(--ink-muted)", textDecoration: "underline" }}>
                    {n.pool.slice(0,6)}…{n.pool.slice(-4)}
                  </a>
                ) : "—"}
              </td>
              <td>
                {n.token && (
                  <a href={`https://robinhoodchain.blockscout.com/token/${n.token}`} target="_blank" rel="noreferrer" className="btn-ghost" data-testid={`open-new-${n.ticker}`}>
                    Open
                  </a>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {lastRead && (
        <div style={{ color: "var(--ink-muted)", fontSize: 11.5, marginTop: 18, letterSpacing: "0.02em" }}>
          Last read {lastRead.toLocaleTimeString()} · Uniswap V3 PoolCreated events, chain 4663.
        </div>
      )}
    </div>
  );
}
